/* LinkAndSyncSummaryComponent.js */

"use strict";

const {EventEmitter} = require("events");
const Renderer = require("./LinkAndSyncSummaryRenderer");

class LinkAndSyncSummaryComponent extends EventEmitter {
    constructor(linkAndSyncResults, logger) {
        super();
        this._logger = logger;
        this._linkAndSyncResults = linkAndSyncResults;
        this._renderer = new Renderer(this);
        this._registerListeners();
        this._renderer.render();
    }

    _registerListeners() {
        // Add your event listener registrations here if needed.
    }

    _unregisterListeners() {
        // Add your event listener unregistrations here if needed.
    }

    get renderer() {
        return this._renderer;
    }

    get logger() {
        return this._logger;
    }

    shutdown() {
        this._unregisterListeners();
        return this._renderer
            .shutdown()
            .then(() => {
                this._logger = this._renderer = this._linkAndSyncResults = undefined;
            })
            .catch((err) => {
                this._logger.warn({error: err}, "linkAndSyncSummaryComponent.shutdown() error.");
            });
    }

    sendOk() {
        this._context.resolve({});
    }

    set "$teve.ui.context"(context) {
        //jshint ignore:line
        this._context = context;
    }

    getLinkAndSyncResults() {
        return this._linkAndSyncResults;
    }

    get linkAndSyncResults() {
        return this.getLinkAndSyncResults();
    }
}

module.exports = LinkAndSyncSummaryComponent;
